import Data from './Data';

const slateTableBlockSidebar = (props) => {
  return <Data {...props} />;
};

export default slateTableBlockSidebar;
